
import {Component, Vue} from 'vue-property-decorator';
import DynamicTableSimpleAsync from '@/components/datatables/DynamicTableSimpleAsync.vue';
import {dispatchGetAccessLogs, dispatchGetPrinterLogs} from '@/store/main/actions';
import {readAccessLogs, readPrinterLogs} from '@/store/main/getters';

@Component({
  components: {DynamicTableSimpleAsync},
})
export default class AccessLogList extends Vue {

  public headers = [
    // {text: this.$t('action'), value: 'action', align: 'center', filterable: false, sortable: false },
    {text: this.$t('created_by_user'), sortable: false, value: 'created_by_user', align: 'left', type: 'user_object'},
    {text: this.$t('created_at'), sortable: false, value: 'created_at', align: 'left', type: 'date'},
    {text: this.$t('document_id'), sortable: true, value: 'document_id', align: 'right'},
    {text: `${this.$t('module_name')}`, sortable: true, value: 'module_name', align: 'right'},
    {text: `${this.$t('method')}`, sortable: true, value: 'method', align: 'right'},
    {text: `${this.$t('client_ip')}`, sortable: true, value: 'client_ip', align: 'right'},
    {text: `${this.$t('path_params')}`, sortable: true, value: 'path_params', align: 'right'},
    {text: `${this.$t('query_params')}`, sortable: true, value: 'query_params', align: 'right'},
  ];

  private numberOfPages: number = 0;
  private totalItems: number = 0;

  private get dataset() {
    return readAccessLogs(this.$store);
  }

  public async loadDataAPI(payload: any) {
    payload.with_stats = false;
    const response = await dispatchGetAccessLogs(this.$store, payload);

    if (response) {
      this.totalItems = response?.total_items;
      this.numberOfPages = response?.total_items_page;
    }
  }

  public async mounted() {
    // location.reload();
    // await dispatchGetAccessLogs(this.$store);
  }

}
